<div class="row">
  <div class="col-md-12">
    <div class="card ">
      <div class="card-header ">
        <h5 class="card-title">Emails Logs</h5>
        <p class="card-category">
          <select class="form-control">
            <option [ngValue]="itm" *ngFor="let itm of subscriptions">
              {{itm.projectShortName}} • {{itm.apiKey}}
            </option>
          </select>
        </p>
      </div>
      <div class="card-body "><div class="chartjs-size-monitor" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; overflow: hidden; pointer-events: none; visibility: hidden; z-index: -1;"><div class="chartjs-size-monitor-expand" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:1000000px;height:1000000px;left:0;top:0"></div></div><div class="chartjs-size-monitor-shrink" style="position:absolute;left:0;top:0;right:0;bottom:0;overflow:hidden;pointer-events:none;visibility:hidden;z-index:-1;"><div style="position:absolute;width:200%;height:200%;left:0; top:0"></div></div></div>
      <!-- BODY-->
      <div class="table-responsive">
        <i *ngIf="isLoadingLogs" class="fa fa-spinner fa-pulse fa-fw"></i>
        <table *ngIf="!isLoadingLogs" class="table">
          <thead class=" text-primary">
            <tr><th>
              Date Sent
            </th>
            <th>
              Email Type
            </th>
            <th>
              Template
            </th>
            <th>
              From
            </th>
            <th>
              To
            </th>
            <th>
              Subject
            </th>
          </tr></thead>
          <tbody>
            <tr *ngFor="let itm of emailLogs">
              <td>
                {{itm.dateSent}}
              </td>
              <td>
                {{itm.emailType}}
              </td>
              <td>
                {{itm.templateId}}
              </td>
              <td>
                {{itm.from}}
              </td>
              <td>
                {{itm.to}}
              </td>
              <td>
                {{itm.subject}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>      
    
      <pagination *ngIf="pagination" [boundaryLinks]="true" [totalItems]="pagination.totalItems"
        [itemsPerPage]="pagination.itemsPerPage"
        [(ngModel)]="pagination.currentPage"
        (pageChanged)="pageChange($event)"
        previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;">
      </pagination>

      <!-- END BODY -->
      </div>
      <div class="card-footer ">
        <hr>
        <div class="stats" *ngIf="emailLogs">
          <i class="fa fa-history"></i> {{pagination?.totalItems}} records.
        </div>
      </div>
    </div>
  </div>
  


</div>


  <app-emailsChart *ngIf="selectedSubscription" [currentSubscription]="selectedSubscription"></app-emailsChart>


